import React, { useEffect } from 'react'
import SearchStringOrIntReq from '../../Classes/Models/Requests/SearchStringOrIntReq'
import SessionsApi from '../../Classes/API/Administration/SessionsApi'
import MDTypography from 'components/MDTypography'
import Swal from 'sweetalert2'
import { useContext, useState } from 'react'
import { UserContext } from 'App';
import './style.scss'

const AddmissionButton = ({ AccSession, setIsLoaded }) => {
    const User = useContext(UserContext);
    const [AccountingSession, setAccountingSession] = useState(AccSession);
    useEffect(() => {
        setAccountingSession(AccSession);
    }, [AccSession])
    if(!User){
        return <div>Loading...</div>
    }
    if(User.userType != "Admin" && User.userType != "AccountingEmployee"  && User.userType != "Therapist" && User.userType != "FloorManager" && User.userType != "AppointmentEmployee" && User.userType != "SubAdmin"){
        if(AccountingSession.isAdmitted == true){
            return <span className='badge badge-success'>Admitted</span>
        }
        else{
            return <span className='badge badge-danger'>Not Admitted</span>
        }
    }
    const ToggleSessionAdmission = async (AccountingSession) => {
        Swal.fire({
            icon: 'info',
            title: 'Loading...',
            text: 'Please wait...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        if(AccountingSession.isAdmitted && User.userType != "Admin" && User.userType != "SubAdmin"){
            Swal.fire({
                title: 'Invalid Permission',
                text: 'You are not allowed to un-admit this session',
                icon: 'error',
                confirmButtonText: 'Ok'
            })

            return;
        }
        let req = new SearchStringOrIntReq();
        req.SearchInt = AccountingSession.id;

        let res = await SessionsApi.ToggleAccountingSessionAdmission(req);

        if (res.status == "Success") {
            console.log("res.data", res.data);
            Swal.fire("Success", res.message, "success");

            // window.location.reload();
            setAccountingSession(res.data);
            if(setIsLoaded){
                setIsLoaded(false);
            }
        }
        else {
            Swal.fire("Failed", res.message, "error");
        }
    }

    let buttonText = "";
    let buttonClass = "";
    let buttonDisabled = false;

    if (AccountingSession.isAdmitted) {
        buttonText = "UnAdmit";
        buttonClass = "btn btn-dark";

    }
    else if(AccountingSession.isAdmittable == false) {
        buttonText = "UnAdmittable";
        buttonClass = "btn btn-info";
        // buttonDisabled = true;
    }
    if (AccountingSession.isAbsent) {
        
        buttonText = "Absent";
        buttonClass = "btn btn-danger";
        buttonDisabled = true;
    }
    if (!AccountingSession.isPaidFor) {
        buttonClass = "btn btn-outline-danger";
        buttonDisabled = true;
        buttonText = "Not Paid";

    }
    else{
        if(buttonText == ""){
            buttonText = "Admit";
            buttonClass = "btn btn-success";
        }
    }

    if(AccountingSession.isException){
        buttonDisabled = false;
    }

    return (
        <MDTypography variant="button" fontWeight="regular" color="text">
            <button disabled={buttonDisabled} onClick={() => ToggleSessionAdmission(AccountingSession)} className={buttonClass}>{buttonText} {AccountingSession.isException && "EXCEPTION"}</button>
        </MDTypography>
    )
}

export default AddmissionButton